import {Col, Container, Row} from "reactstrap";
import React, {useEffect, useState} from "react";
import ViberHeader from "../../../components/header-new/ViberHeader";
import CardsFooter from "../../../components/Modals/Footers/CardsFooter";
import {searchCourseCertificateById} from "../../../services/courses";

export default function PreviewCertificate() {

    const [certificateDetails, setCertificateDetails] = useState(
        {
            student: {
                id: 0,
                name: "",
                nameOnCertificate: "",
                first_name: null,
                gender: null,
                school: null,
                address: null,
                district: null,
                province: null,
                email: null,
                mobile: null,
                grade: null,
                dob: null,
                status: null
            },
            course: {
                courseId: 0,
                name: "",
                courseNameOnCertificate: "",
                startDate: null,
                endDate: null,
                status: null,
                noOfSemesters: 0,
                noOfInstallments: 0,
                description: null,
                imageUrl: null,
                videoUrl: null,
                videoSize: 0,
                totalFee: null,
                created: null,
                updated: null,
                coursesDayTimes: null,
                courseTeachers: null,
                courseInstallmentList: null,
                nextDayOfCourseSession: null,
                zoomJoinUrl: null,
                zoomMeetingId: null,
                zoomMeetingPassword: null,
                zoomStartUrl: null
            },
            certificate: {
                id: 0,
                courseEnrollId: 0,
                certificateStatus: "",
                dateOnCertificate: "",
                certificateURL: "",
                created: "",
                modified: "",
                courseIdTemp: 0,
                studentIdTemp: 0,
                courseEnrollIdTemp: 0
            }
        }
    )

    useEffect(() => {
        (async function fetch() {
            let items = window.location.href.split("/");
            if (items.length > 0) {
                const certificateId = items[items.length - 1];
                const response = await searchCourseCertificateById(certificateId);
                if (response) {
                    const {success, body} = response;
                    if (success && body) {
                        setCertificateDetails(body);
                    }
                }
            }
        })()
    }, []);

    return (
        <div>
            <ViberHeader/>
            <div style={{marginTop: 30}}>
                <Container fluid>
                    <Row style={{
                        display: 'flex',
                        border: '1px solid none',
                        justifyContent: 'center',
                        alignItems: 'center'
                    }}>
                        <Col lg={6}>
                            <div style={{
                                display: 'flex',
                                flexDirection: 'column',
                                gap: '10px',
                                fontSize: "1.2rem",
                                justifyContent: 'center',
                                alignItems: 'start'
                            }}>
                                <div>Course Name : <span style={{fontWeight: 'bold'}}>{certificateDetails.course.name}</span>
                                </div>
                                <div>Student Name : <span style={{fontWeight: 'bold'}}>{certificateDetails.student.name}</span></div>
                                <div>Issued Date : <span style={{fontWeight: 'bold'}}>{certificateDetails.certificate.dateOnCertificate}</span></div>
                                <iframe style={{aspectRatio: '4/5.23'}} src={certificateDetails.certificate.certificateURL}
                                        width={"100%"}/>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>

            <div style={{marginTop: 20}}>
                <CardsFooter/>
            </div>
        </div>
    );
}